<mat-dialog-content style="height: 35vh;">
    <div layout="row" layout-align="center center">
        <div style="margin-bottom: 2%;">
            <strong >{{titulo}}</strong>
        </div>
        <div class="mod-container" style="margin-top: 10px;">
            <mat-form-field style="margin-bottom: 0px; width: 60%;">
                <input matInput placeholder="Plan de la obra social" 
                    [(ngModel)]=nombre>
            </mat-form-field>
        </div>
        <div class="mod-container" style="margin-top: 0px;">
            <mat-checkbox style="margin-bottom: 20px; margin-top: 10px;" color="primary"
                [(ngModel)]=habilitado>Habilitado
            </mat-checkbox>
        </div>
    </div>
</mat-dialog-content>
<div style="text-align: center;">
    <table style="width: 100%; text-align: center;">
        <tr>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="cerrar('cancela')">
                    <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Cancelar
                </button>
            </td>
            <td style="width: 20%;"></td>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="almacenar()" style="margin-left: 30px;">
                    <i class="fas fa-save fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Almacenar
                </button>
            </td>
        </tr>
    </table>
</div>
